/** One theme per weekday, Accra time. Modifiers are read by the game and trusted limits on the server. */
export interface DailyTheme {
  day: number;
  name: string;
  blurb: string;
  fareMultiplier: number;
  trafficMultiplier: number;
  crowdMultiplier: number;
}

export const DAILY_THEMES: readonly DailyTheme[] = [
  { day: 0, name: 'Church Sunday', blurb: 'Light traffic, church crowds', fareMultiplier: 1, trafficMultiplier: 0.6, crowdMultiplier: 1.2 },
  { day: 1, name: 'Go-slow Monday', blurb: 'Heavy traffic everywhere', fareMultiplier: 1, trafficMultiplier: 1.5, crowdMultiplier: 1 },
  { day: 2, name: 'Makola Market Tuesday', blurb: 'Big crowds at the stops', fareMultiplier: 1, trafficMultiplier: 1.1, crowdMultiplier: 1.5 },
  { day: 3, name: 'Rainy Wednesday', blurb: 'Slow and steady', fareMultiplier: 1.2, trafficMultiplier: 1, crowdMultiplier: 1 },
  { day: 4, name: 'Double Fare Thursday', blurb: 'Every fare pays double', fareMultiplier: 2, trafficMultiplier: 1, crowdMultiplier: 1 },
  { day: 5, name: 'Friday Wear', blurb: 'Everyone in kente and print', fareMultiplier: 1.2, trafficMultiplier: 1.1, crowdMultiplier: 1.2 },
  { day: 6, name: 'Wedding Saturday', blurb: 'Party crowds, generous tips', fareMultiplier: 1.3, trafficMultiplier: 0.9, crowdMultiplier: 1.3 },
];

/** Accra is on GMT all year, so the UTC weekday is the Accra weekday. */
export function themeFor(now: number): DailyTheme {
  return DAILY_THEMES[new Date(now).getUTCDay()] ?? DAILY_THEMES[0]!;
}

export const MAX_FARE_MULTIPLIER = Math.max(...DAILY_THEMES.map((t) => t.fareMultiplier));
